export default [
    {path: ':crop_id'},
    {path: ':crop_id/add'},
    {path: ':crop_id/edit/:form_id'},
    {path: ':crop_id/fields/:form_id'},
    {path: ':crop_id/details/:form_id'},
]